import {
  formatEstimateReplyPriceInKorean,
  formatPriceWithCommas,
} from "@/utils/priceFormat";

export default {
  computed: {
    replyPricePreview() {
      return (
        this.replyForm.price || "제품별 견적가를 입력하면 총 금액이 표시됩니다."
      );
    },
    hasSpecialPromotion() {
      return Boolean(
        this.estimate &&
          this.estimate.reply &&
          this.estimate.reply.promotion &&
          this.estimate.reply.promotion.enabled
      );
    },
    promotionPriceText() {
      const promotion =
        (this.estimate &&
          this.estimate.reply &&
          this.estimate.reply.promotion) ||
        {};
      return formatPriceWithCommas(promotion.price);
    },
    completedPromotionPriceKoreanText() {
      const promotion =
        (this.estimate &&
          this.estimate.reply &&
          this.estimate.reply.promotion) ||
        {};
      return formatEstimateReplyPriceInKorean(promotion.price);
    },
    promotionStatusText() {
      if (!this.hasSpecialPromotion) return "";

      const promotion = this.estimate.reply.promotion;
      if (!promotion.customerViewedAt) return "고객 확인 전";
      if (
        promotion.expiresAt &&
        new Date(promotion.expiresAt).getTime() <= Date.now()
      ) {
        return "혜택 종료";
      }
      return "고객 확인 후 24시간 혜택 진행 중";
    },
  },
};
